import * as React from 'react';
import * as RequestParams from '../config/RequestParams';
import styles from './Iframe.module.css';
import { renderToStaticMarkup } from 'react-dom/server';
const Iframe = ({ baseUrl, size, showCode, supportedSizes }) => {
    const [sizeWidth, sizeHeight] = size === 'auto' ? ['300', '300'] : size === 'API' ? ['600', '600'] : size.split('x');
    const [width, setWidth] = React.useState(+sizeWidth);
    const [height, setHeight] = React.useState(+sizeHeight);
    var iframeUrl = new URL(baseUrl);
    const [adServerClickPrefix] = RequestParams.getAdServerClickPrefix(iframeUrl.search);
    iframeUrl.searchParams.delete(RequestParams.RequestParam.adServerClickPrefix);
    iframeUrl.searchParams.set(RequestParams.RequestParam.size, size);
    iframeUrl.searchParams.forEach((value, key) => {
        if (value.includes('{size}')) {
            iframeUrl.searchParams.set(key, value.replace('{size}', size));
        }
    });
    iframeUrl.hash = '';
    if (adServerClickPrefix) {
        iframeUrl.searchParams.append(RequestParams.RequestParam.adServerClickPrefix, adServerClickPrefix);
    }
    const attributes = {
        width: width,
        height: height,
        loading: 'lazy',
        style: { border: 'none', overflow: 'hidden' },
        scrolling: 'no'
    };
    function onKeyDown(event) {
        if (event.key === 'Enter') {
            event.currentTarget.blur();
        }
    }
    const configuratorIframeUrl = new URL(iframeUrl.toString());
    configuratorIframeUrl.searchParams.set(RequestParams.RequestParam.configurator, 'true');
    const code = renderToStaticMarkup(React.createElement("iframe", Object.assign({ key: size, title: size }, attributes, { src: iframeUrl.toString() })));
    return (React.createElement("div", null,
        React.createElement("h3", null,
            "Size ",
            size),
        React.createElement("iframe", Object.assign({ key: size, title: size }, attributes, { src: configuratorIframeUrl.toString() })),
        showCode ? (React.createElement(React.Fragment, null,
            size === 'auto' ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.buttonPanel },
                    React.createElement("input", { type: "number", defaultValue: width, onBlur: e => setWidth(+e.target.value), onKeyDown: onKeyDown }),
                    React.createElement("span", null, "x"),
                    React.createElement("input", { type: "number", defaultValue: height, onBlur: e => setHeight(+e.target.value), onKeyDown: onKeyDown }),
                    React.createElement("span", null, `= ${RequestParams.getAutoSize(width, height, supportedSizes)}`)))) : null,
            React.createElement("div", { className: styles.code }, code),
            React.createElement("div", { className: styles.buttonPanel },
                React.createElement("div", { className: styles.button, onClick: () => navigator.clipboard.writeText(code) }, "Copy to clipboard"),
                React.createElement("div", { className: styles.button, onClick: () => window.open(iframeUrl.toString(), '_blank') }, "Open in new window")))) : null));
};
export default Iframe;
//# sourceMappingURL=Iframe.js.map